import React from 'react';
import Helmet from 'react-helmet';
import Header from '../common/Header';
import Link from '../common/TrackedLink';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';

class SiteMap extends React.Component {
	render() {
		return (
			<div>
				<Helmet title="Site Map | SentrySafe" />

				<Breadcrumb>
					<BreadcrumbItem label="Site Map" />
				</Breadcrumb>

				<Header title="Site Map" />

				<section className="section section-site-map">
					<div className="section-content row">
						<div className="col">
							<ul>
								<li>
									<Link to="/">Home</Link>
								</li>
								<li>
									<Link to="/products">Products</Link>
									<ul>
										<li>
											<Link to="/business-safes">Business Safes</Link>
										</li>
										<li>
											<Link to="/cash-boxes">Cash Boxes</Link>
										</li>
										<li>
											<Link to="/document-safes">Document Safes</Link>
										</li>
										<li>
											<Link to="/fire-safes">Fire Safes and Fire Bag</Link>
										</li>
										<li>
											<Link to="/pistol-safes">Pistol Safes</Link>
										</li>
										<li>
											<Link to="/portable-safes">Portable Safes</Link>
										</li>
										<li>
											<Link to="/security-safes">Security Safes</Link>
										</li>
										<li>
											<Link to="/fire-waterproof-safes">Water and Fireproof Safes</Link>
										</li>
									</ul>
								</li>
								<li>
									<Link to="/learn/buying-guide">Buying Guide</Link>
								</li>
								<li>
									<Link to="/learn/about-us">About SentrySafe</Link>
								</li>
								<li>
									<Link to="/learn/customer-stories">Stories</Link>
								</li>
								<li>
									<Link to="/learn/press-room">Press Room</Link>
								</li>
								<li>
									<Link to="/where-to-buy">Where To Buy</Link>
								</li>
								<li>
									<Link to="/support">Support</Link>
									<ul>
										<li>
											<Link to="/support/check-serial-number">Check Your Electronic Fire Safe</Link>
										</li>
										<li>
											<Link to="/support/faqs">FAQs</Link>
										</li>
										<li>
											<Link to="/support/find-your-model-or-serial-number">Find Your Model or Serial Number</Link>
										</li>
										<li>
											<Link to="/support/lost-key-combo">Lost Key or Combination</Link>
										</li>
										<li>
											<Link to="/support/product-manuals">Product Manuals</Link>
										</li>
										<li>
											<Link to="/support/videos">Videos</Link>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default SiteMap;


// WEBPACK FOOTER //
// ./src/pages/siteMap/Index.js